export enum MULTISELECT_TYPE {
    STATSTASK = 'StatTaskedFileItem',
    SERVICES = 'AddingServices',
    OTHER_SERVICES = 'OtherAddingServices',
}
